import type { RxCollection } from 'rxdb';

import type { DatabaseUpsertTransformer } from '../../../../types/database';
import logger from '../../logger';

export default function getUnknownRootKeysTransformer(
  collection: RxCollection,
): DatabaseUpsertTransformer {
  const knownRootKeys = Object.keys(collection.schema.jsonSchema.properties).filter(
    (key) => !key.startsWith('_'),
  );

  logger.debug('[upsertTransformers] getUnknownRootKeysTransformer', {
    collectionName: collection.name,
    knownRootKeys,
  });

  return function unknownRootKeysTransformer(plainData: object) {
    for (const key of Object.keys(plainData)) {
      if (key.startsWith('_') || knownRootKeys.includes(key)) {
        continue;
      }
      // Explanation: deleting unknown root keys from a generic object — key is a dynamic string from Object.keys
      // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-type-assertion
      delete (plainData as any)[key];
    }
  };
}
